import i18n from 'i18n';
import { UserRole } from 'types';

export const USER_OPTIONS = [
  { value: UserRole.Employee, label: i18n.t('inviteEmployee.form.options.employee') },
  { value: UserRole.Manager, label: i18n.t('inviteEmployee.form.options.manager') },
];
